import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@14.2.2_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["CustomScrollLoader"] */ "/app/src/components/CustomScrollLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/VersionReporter/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/context/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContextProvider"] */ "/app/src/context/ToastContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/styles/fonts.css");
